export default [
	/** @action */
	{
		event: 'notification:remove',
		label: i18n.t('i18n.remove'),
		wrapper(view, e) {
			return [view.model];
		},
	},
	/** @action */
	{
		event: 'notifications',
		label: i18n.t('i18n.viewNotifications'),
	},
	/** @action */
	{
		event: 'notifications:route',
		label: i18n.t('i18n.viewNotifications'),
		route: 'notifications',
	},
	/** @action */
	{
		event: 'notifications:routed',
		label: i18n.t('i18n.notifications'),
	},
];
